import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DialogData {
    firstName: string;
    lastName: string;
}

@Component({
    selector: 'app-confirm-delete-modal',
    template: `
        <div class="confirm-delete-modal">
            <h2 mat-dialog-title>{{ 'pages.users_management.delete_confirmation.title' | translate }}</h2>
            
            <mat-dialog-content>
                <p>{{ 'pages.users_management.delete_confirmation.message' | translate: { firstName: data.firstName, lastName: data.lastName } }}</p>
            </mat-dialog-content>
            
            <mat-dialog-actions align="end">
                <button mat-button [mat-dialog-close]="false">
                    {{ 'general.actions.cancel' | translate }}
                </button>
                <button mat-raised-button 
                        color="warn" 
                        [mat-dialog-close]="true">
                    {{ 'general.actions.delete' | translate }}
                </button>
            </mat-dialog-actions>
        </div>
    `,
    styles: [`
        mat-dialog-content {
            margin: 20px 0;
        }
        
        mat-dialog-actions {
            padding-top: 20px;
        }
    `]
})
export class ConfirmDeleteModalComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmDeleteModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {}
}
